import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { getConfig } from './config';

i18n
  // Load translations from the /public/locales folder
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Configure i18next
  .init({
    fallbackLng: 'en',
    debug: getConfig().env === 'dev',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Set to true for development
    react: {
      useSuspense: true,
    },
  });

export default i18n;
